import produce from 'immer';
import {
  USER_ITEM_ITEM_LIST_REQUEST,
  USER_ITEM_ITEM_REMOVE_REQUEST,
} from '../../constants/app/userItemManageConstants';

const initialState = {

}

const userItemManageReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case USER_ITEM_ITEM_LIST_REQUEST:
      break;
    case USER_ITEM_ITEM_REMOVE_REQUEST:
      break;
    default:
      break;
  }
});

export default userItemManageReducer;
